import axios from "axios";
import toast from "react-hot-toast";
import { config } from "../../Utils/helpers";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getBrandsList = (brandsData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_BRANDS_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/brands/list`,
        brandsData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_BRANDS_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_BRANDS_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_BRANDS_LIST_FAILED",
        payload: error?.data?.response?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addBrand = (brandsData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });

    try {
      dispatch({ type: "ADD_BRANDS_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/brands/add`,
        brandsData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_BRANDS_SUCCESS", payload: data });
        toast.success("Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_BRANDS__FAILED", payload: data });
        toast.error("Something Went Wrong!!");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_BRANDS__FAILED",
        payload: error?.data?.response?.message,
      });
      toast.error(error?.response?.data?.message);
      return error?.response?.data?.message;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
